import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LatestCreations from "./components/LatestCreations";
import Bestsellers from "./components/Bestsellers";
// import Stats from "./components/Stats";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <LatestCreations />
      <Bestsellers />
      {/* <Stats /> */}

    </div>
  );
}

export default App;
